import LocalStorage from '../../../helpers/LocalStorage';
import QueryParams from '../../../helpers/QueryParams';
import DateTime from '../../../helpers/DateTime';
import MachineAgrementFormValidation from './MachineAgrementFormValidation';

/**
 * Machine Agreement review class
 */
export default class MachineAgreementReview {
    constructor() {
        this.dateTime = new DateTime();
        this.validThroughDate = this.dateTime.addMonths(new Date(), 12).toString();
        this.queryParams = new QueryParams();
        this.query = this.queryParams.getQueryParamsAsObject();
        this.actionsForWebSales();
        this.validation = new MachineAgrementFormValidation();
        this.storage = new LocalStorage();
        this.payload = {};
    }

    /**
     * @description Skipping step one in creating an agreement
     * when user/sales come from web sales CRM
     * @returns void
     */
    actionsForWebSales() {
        if (Object.getOwnPropertyNames(this.query).length > 0 && this.query.agreement !== '') {
            document.querySelector('#step1View').classList.add('hidden');
            document.querySelector('#step2View').classList.remove('hidden');
            document.querySelector('#Step2Back').classList.add('hidden');
            document.querySelector('#Step2Back').parentNode.classList.add('hidden');
        }
    }

    /**
     * @description Set Reciever data when fields change
     * @returns void
     */
    recieverEventListerner() {
        for (const formItem of document.getElementsByClassName('.machineAgreementData')) {
            formItem.addEventListener('change', this.storeData);
        }
    }

    /**
     * @description Store data from payload
     * @returns void
     */
    storeData() {
        let fields = '.machineAgreementData';

        if (Object.getOwnPropertyNames(this.query).length > 0 && this.query.agreement !== '') {
            this.setPayloadByQueryParams();
            fields = '.step2';
        } else {
            this.setRecieverFieldsFromInput();
        }

        for (const item of document.querySelectorAll(fields)) {
            this.payload[item.id] = item.value ? item.value : null;
        }

        this.storage.setItem('machineAgreement', this.payload);
        this.validation.checkForm('reciever');

        
    }

    /**
     * @description getting userid and name from markup when accessing the app from external
     * @returns {string}
     */
    setCustomerByMarkup() {   
        let customerName = document.querySelector('#customer-popup .customer-name').innerText;
        let customerId = document.getElementById('customerNumberElementId').value; 
        return `${customerId} - ${customerName}`;
    }

    /**
     * @description Setting payload from Helper
     * @param {Object} payLoadData
     * @returns void
     */
    preparePayLoad(payLoadData) {
        this.payload[Object.keys(payLoadData)[0]] = payLoadData[Object.keys(payLoadData)[0]];
        this.storeData();
    }

    /**
     * @description Auto fill and click on form elements for web sales
     * @returns void
     */
    setPayloadByQueryParams() {

        let agreementName = !isNaN(this.query.agreement.charAt(0))
            ? 'MachinePurchasingAgreement'
            : 'MachineServiceAgreement';

        const templateId = document
            .querySelector(`a[data-template="${agreementName}"]`)
            .parentNode.getAttribute('data-value');

        const templateName = document.querySelector(
            `a[data-template="${agreementName}"]`
        ).innerText;

        document.querySelector('#reviewAgrementTemplate').innerHTML = templateName;
        this.payload.signingTemplateId = templateId;

        // Agreement number
        // ---------------------------------------------
        document.querySelector('#reviewAgreementNumber').textContent = this.query.agreement;
        this.payload.agreementNumber = this.query.agreement;

        // Receiver Name
        // ---------------------------------------------
        document.querySelector('.review_receiver_name').innerHTML = document.querySelector('#ReceiverName').value;

        // Agreement name
        this.payload.agreementName = agreementName;

        // PDF Document generated by system
        // ---------------------------------------------
        const documentName = document.querySelector('#pdfDocumentName').value;
        const documentUrl = document.querySelector('#pdfDocument').value;
        const documentLink = document.querySelector('#reviewAgreementDocuments');
        documentLink.textContent = documentName;
        documentLink.href = documentUrl;
        this.payload.documents = [
            {
                documentName: document.querySelector('#pdfDocumentName').value,
                documentType: 'pdf',
                document: document.querySelector('#pdfDocument').value,
            },
        ];

        // Customer number - fetching data from markup.
        // ---------------------------------------------
        document.querySelector('#reviewCustomerNumberName').innerText = this.setCustomerByMarkup(); 

        // End date
        // ---------------------------------------------------------------------
        this.payload.validThroughDate = this.validThroughDate;
        this.storage.setItem('machineAgreement', this.payload);
    }

    /**
     * @description Set Review data from Form
     * @returns void
     */
    setRecieverFieldsFromInput() {
        // Agreement template
        // ---------------------------------------------
        if (document.querySelector('.machine-templates.selected')) {
            document.querySelector('#reviewAgrementTemplate').innerHTML = document.querySelector(
                '.machine-templates.selected'
            ).innerHTML;
            this.payload.signingTemplateId = document
                .querySelector('.machine-templates.selected')
                .getAttribute('data-value');
        }

        // Agreement number
        // ---------------------------------------------
        if (document.querySelector('#agreementNumber').value) {
            document.querySelector('#reviewAgreementNumber').innerHTML =
                document.querySelector('#agreementNumber').value;
            this.payload.agreementNumber = document.querySelector('#agreementNumber').value;
        }

        // Receiever Name
        // ---------------------------------------------
        document.querySelector('.review_receiver_name').innerHTML =
            document.querySelector('#ReceiverName').value;

        // Agreement name 
        this.payload.agreementName = document.querySelector('#selectTemplate a').innerHTML;

        // PDF Document
        // ---------------------------------------------
        if (document.querySelector('#agreementFile').files?.length > 0) {
            const input = document.querySelector('#agreementFile');
            const documentLink = document.querySelector('#reviewAgreementDocuments');
            const file = input.files[0];
            const url = URL.createObjectURL(file);
            documentLink.textContent = file.name;
            documentLink.href = url;
            
            this.payload.documents = [{
                documentName: file.name,
                documentType: 'pdf',
                document: url
            }];
        }

        // End date
        // ---------------------------------------------------------------------
        this.payload.validThroughDate = this.validThroughDate;
        
        // Set Payload
        // ---------------------------------------------------------------------
        this.storage.setItem('machineAgreement', this.payload);
    }

    /**
     * @description Get payLoad data
     * @returns {} Object
     */
    getPayload() {
        return this.payload;
    }

}
